import {Model} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {gVariable} from '@/services/globalData'
import {Component, Vue} from 'vue-property-decorator'
import Helper from '../services/Helper.js'

@Component
export default class ListView<T extends Model> extends Vue {
  protected store = {
    response: new DataArray(),
    data: [],
    star: false,
    latest: false,
    pending: false,
    due: false,
    dateFrom: '1970-01-01',
    dateTo: '1970-01-01',
    filter: {},
    scrollY: 0,
    sort: '',
    display: 'list',
    promotion: false,
  }

  isForceReload = false

  constructor(props) {
    super(props)

  }

  is_star = false
  is_latest = false
  is_pending = false
  is_promotion = false
  is_due = false

  filter_search_keyword = ''

  dateFrom = new Date().toISOString().substr(0, 10)
  dateTo = new Date().toISOString().substr(0, 10)

  commit_prefix = ''
  base_url = ''

  padItemAmount = 4
  padItemOffset = 0
  scrollY = 0
  startElementIndex = 0

  itemHeight = 72

  maxElementRender = window.innerHeight / this.itemHeight

  items = []

  drawer_ratio = 0.25
  drawer_width = 200
  display_width = 1000

  per_row = 1

  sort = 'code'
  display = 'list'

  skip_first_fetch = false

  resetScroll() {
    const appBody = window.document.getElementById('appBody')
    if (appBody) {
      appBody.scrollTop = 0
    }
  }

  beforeLoad() {

  }
  mounted() {
    console.log('mounted ' + this.commit_prefix)

    this.is_star = this.store.star
    this.is_pending = this.store.pending
    this.is_due = this.store.due
    this.sort = this.store.sort
    this.display = this.store.display
    this.dateFrom = this.store.dateFrom
    this.dateTo = this.store.dateTo

    // console.log('this.dateFrom',this.dateFrom);
    if (this.dateFrom == '' || this.dateFrom == '1970-01-01') {
      let tzoffset = (new Date()).getTimezoneOffset() * 60000
      let tmpDateFrom = new Date(Date.now())
      tmpDateFrom.setDate(1)
      const strDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset))
      this.dateFrom = strDateFrom.toISOString().substr(0, 10)
      // console.log('this.dateFrom',this.dateFrom);
    }

    if (this.dateTo == '' || this.dateTo == '1970-01-01') {
      var tzoffset = (new Date()).getTimezoneOffset() * 60000
      let startOfMonth = (new Date(Date.now() - tzoffset))
      this.dateTo = startOfMonth.toISOString().substr(0, 10)
      // console.log('this.dateFrom',this.dateFrom);
    }

    // let tmpDateFrom = new Date()
    // tmpDateFrom.setDate(tmpDateFrom.getDate() - 7)
    // this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)


    this.setItemHeight(this.display)

    this.maxElementRender = window.innerHeight / this.itemHeight * this.column_no

    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    this.display_width = window.innerWidth - this.drawer_width
    console.log('window.innerWidth', window.innerWidth)

    this.beforeLoad()

    const appBody = window.document.getElementById('appBody')
    if (appBody) {
      appBody.scrollTop = this.store.scrollY
      if(!this.skip_first_fetch) {
        this.getItems()
      }
      // window.addEventListener('scroll', this.onScroll);
      appBody.addEventListener('scroll', this.onScroll)
      //debugger
      this.onScroll({target: appBody})
    }
    window.addEventListener('resize', this.onResize)

  }

  beforeDestroy() {
    this.$store.commit(this.commit_prefix + '_pageOption',
      {
        y: this.scrollY,
        sort: this.sort,
        display: this.display,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      })
  }

  destroyed() {
    window.document.getElementById('appBody')?.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)

    // window.removeEventListener('scroll', this.onScroll);
    // debugger
  }

  onResize() {
    this.maxElementRender = window.innerHeight / this.itemHeight * this.column_no
    this.reCalStartIndex()
    this.reloadItem()
  }

  onScroll(e) {
    this.scrollY = e.target.scrollTop
    this.reCalStartIndex()
  }

  reCalStartIndex() {
    const startIndex = Math.max(0, Math.floor(this.scrollY / this.itemHeight) * this.column_no)
    if (startIndex != this.startElementIndex) {
      this.startElementIndex = startIndex
      this.reloadItem()
    }
  }

  reloadItem() {
    // console.log('reloadItem')
    if (this.startElementIndex + this.maxElementRender * 2 > this.store.data.length) {
      this.infiniteScrolling()
    }


    this.padItemOffset = Math.min(0, this.startElementIndex - this.padItemAmount)
    this.items = this.store.data.slice(Math.max(0, this.startElementIndex - this.padItemAmount), this.startElementIndex + this.maxElementRender + this.padItemAmount)

  }

  clearFilter(name: string) {
    this.store.filter[name].current = []
    this.reload()
  }

  setFilter(name: string, key: string = '', text: string = '') {
    if (name == 'star') {
      this.store.star = this.is_star = !this.is_star
      this.reload()
      return
    }
    if (name == 'pending') {
      if (key === '1') {
        this.store.pending = true
      } else if (key === '0') {
        this.store.pending = false
      } else {
        this.store.pending = this.is_pending = !this.is_pending
      }
      this.store.due = this.is_due = false
      this.store.latest = this.is_latest = false


      this.reload()
      return
    }

    if (name == 'due') {
      this.store.pending = this.is_pending = false
      this.store.due = this.is_due = !this.is_due
      this.store.latest = this.is_latest = false
      this.reload()
      return
    }

    if (name == 'latest') {
      this.store.pending = this.is_pending = false
      this.store.due = this.is_due = false
      this.store.latest = this.is_latest = !this.is_latest
      this.reload()
      return
    }

    if (name == 'promotion') {
      this.is_promotion = !this.is_promotion
      this.store.promotion = this.is_promotion
      this.reload()
      return
    }

    let index = -1
    for (let i in this.store.filter[name].current) {
      if (!this.store.filter[name].current.hasOwnProperty(i))
        continue
      console.log('check key', name, key, this.store.filter[name].current[i])

      if (key == this.store.filter[name].current[i].key) {
        console.log('found key', name, key)
        index = parseInt(i)
        break
      }
    }
    if (index >= 0)
      this.store.filter[name].current.splice(index, 1)
    else
      this.store.filter[name].current.push({key: key, text: text, count: 0})

    console.log('setFilter', index, key, text)
    console.log('this.store.filter', this.store.filter)
    this.reload()
  }


  infiniteScrolling() {
    // return;
    if (gVariable.tabs[this.commit_prefix].isLoad) return
    // console.log('infiniteScrolling')
    // console.log(this.store.response.links)

    gVariable.tabs[this.commit_prefix].isLoad = true

    if (this.store.response.links
      && this.store.response.links.next) {
      Helper.get(this.store.response.links.next)
        .then<{ data: DataArray }>(({data}) => {
          this.$store.commit(this.commit_prefix + '_append', data)
          this.reloadItem()
          gVariable.tabs[this.commit_prefix].isLoad = false
        }).catch(() => gVariable.tabs[this.commit_prefix].isLoad = false)
    } else {
      gVariable.tabs[this.commit_prefix].isLoad = false
    }
  }

  getUrlFilter() {
// debugger
    let url = this.base_url
    let option = ''

    for (const name in this.store.filter) {
      console.log('const name in this.store.filter [' + name + ']')
      if (this.store.filter[name].current.length > 0) {
        option += '&' + name + '=' + this.store.filter[name].current.map(obj => obj.key).join()
      }
    }

    if (this.filter_search_keyword != '') {
      option += '&keyword=' + this.filter_search_keyword
    }
    if (this.is_star) {
      option += '&star=1'
    }
    if (this.is_pending) {
      option += '&pending=1'
    }
    if (this.is_due) {
      option += '&due=1'
    }
    if (this.is_promotion) {
      option += '&promotion=1'
    }
    if (this.dateFrom && this.dateTo) {
      option += `&from_date=${this.dateFrom}&to_date=${this.dateTo}`
    }


    if (this.is_latest) {
      option += '&latest=1'
    } else {
      if (this.sort != '') {
        option += '&sort=' + this.sort
      }
    }


    if (option != '') {
      url = url + '?' + option.substr(1)
    }
    for (const name in this.store.filter) {
      console.log('map', name, this.store.filter[name].current.map(obj => obj.key))
    }
    console.log('getUrlFilter', url)
    return url
  }

  clear_reload() {
    this.filter_search_keyword = ''
    this.reload()
  }

  reload() {
    gVariable.tabs[this.commit_prefix].isLoad = true
    this.resetScroll()

    let url = this.getUrlFilter()
    const that = this


    Helper.get(url)
      .then<{ data: DataArray }>(({data}) => {

        that.$store.commit(this.commit_prefix + '_response', data)

        that.reloadItem()
        gVariable.tabs[this.commit_prefix].isLoad = false

        this.onListLoaded(data)

      }).catch(() => gVariable.tabs[this.commit_prefix].isLoad = false)
  }


  onListLoaded(data) {
    return
  }

  getItems() {
    if (!this.isForceReload && this.store.response &&
      this.store.response.data &&
      this.store.response.data.length > 0) {
      this.reloadItem()
    } else {
      this.reload()
    }
  }

  setItemHeight(display) {
    switch (this.display) {
      case 'list':
        this.itemHeight = 72
        break
      case 'column2':
        this.itemHeight = 96
        break
      case 'grid':
        this.itemHeight = 312
        break
    }
  }

  changeDisplay(display) {
    this.display = display

    this.setItemHeight(display)

    this.onResize()
  }

  changeSort(sort) {
    this.sort = sort
    this.reload()
  }


  get column_no() {
    switch (this.display) {
      case 'list':
        return 1
      case 'column2':
        return 2
      case 'grid':
        return 4
    }
    return 1
  }

  get column_width() {
    return this.display_width / this.column_no

  }


}
